// import '../styles/player.css';

import React, { Component } from 'react';
import ytPlayerSDK from '../sdks/YtPlayerSDK.js'

class Player extends Component {

  constructor() {
    super()
    this.state = {
      height: 0
    }
    this.interval = null
  }

  componentWillUnmount() {
    clearInterval(this.interval)
    window.removeEventListener('resize', this.setHeight)
  }

  componentDidMount() {

    // init player
    ytPlayerSDK.ready.then((YT) => {

      let params = {
        height: '100%',
        width: '100%',
        playerVars: {
          controls: 0,
          modestbranding: 1,
          rel: 0,
          showinfo: 0,
          // loop: 1
        },
        events: {
          onReady: this.onReady,
          onStateChange: this.onStateChange
        }
      }
      this.player = new YT.Player(this.refs.playerIframe, params)

    })

    this.setHeight()
    window.addEventListener('resize', this.setHeight)

  }

  setHeight = () => {
    let width = document.querySelector('.player').offsetWidth
    let height = width*9/16
    this.setState({ height })
  }

  onReady = () => {
    this.loadVideo()
  }

  loadVideo = () => {
    let { id, start } = this.props.params
    let params = {
      videoId: id,
      startSeconds: start,
    }
    this.player.loadVideoById(params)
  }

  onProgress = () => {
    let { start, end } = this.props.params
    let currentTime = this.player.getCurrentTime()
    if (currentTime >= end) {
      this.player.seekTo(start)
    }
  }

  onStateChange = (e) => {
    if (window.YT.PlayerState.PLAYING) {
      this.interval = setInterval(this.onProgress, 100)
    }
  }

  render() {
    return (
      <div className="player" style={{height: this.state.height}}>
        <div ref="playerIframe" className="player__video" ></div>
      </div>
    );
  }
}

export default Player



/** WEBPACK FOOTER **
 ** ./src/scripts/components/Player.js
 **/